<div class="navbar-nav">
  <div class="progress-bar-table" [class.inactive]="step() === 0">
    <div class="step step1" [class.active]="step() === 1">
      <div class="label">Start</div>
      <div class="circle-container">
        <div routerLink="/start" class="outer-circle">
          <div class="inner-circle"></div>
        </div>
      </div>
      <div class="line-right"></div>
    </div>
    <div class="step step2" [class.active]="step() === 2">
      <div class="label">Box</div>
      <div class="circle-container">
        <div (click)="goToBoxCategories()" class="outer-circle">
          <div class="inner-circle"></div>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="step step3" [class.active]="step() === 3">
      <div class="label">Size & Paper</div>
      <div class="circle-container">
        <div (click)="goToBoxOptions()" class="outer-circle">
          <div class="inner-circle"></div>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="step step4" [class.active]="step() === 4">
      <div class="label">Design</div>
      <div class="circle-container">
        <div (click)="goToDesigner()" class="outer-circle">
          <div class="inner-circle"></div>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="step step5" [class.active]="step() === 5">
      <div class="label">Review</div>
      <div class="circle-container">
        <div class="outer-circle">
          <div class="inner-circle"></div>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="step step6" [class.active]="step() === 6">
      <div class="label">Checkout</div>
      <div class="circle-container">
        <div routerLink="/cart" class="outer-circle">
          <div class="inner-circle"></div>
        </div>
      </div>
      <div class="line-left"></div>
    </div>
  </div>
</div>
